import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Container from 'components/Container';
// import Paper from '@mui/material/Paper';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import { assets } from 'assets/assets';

const Hero = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const LeftSide = () => (
    <Box
      data-aos={isMd ? 'fade-right' : 'fade-up'}
      height="fit-content"
      sx={{
        width: 'fit-content',
        marginX: 'auto',
      }}
    >
      <Typography
        sx={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
        }}
        gutterBottom
        color={'text.secondary'}
      >
        Coworking spaces
      </Typography>
      <Box marginBottom={2}>
        <Typography
          variant="h3"
          component="h1"
          color="text.primary"
          sx={{
            fontWeight: 700,
          }}
        >
          Coworking{' '}
          <Typography
            color={'primary'}
            component={'span'}
            variant={'inherit'}
            sx={{
              background: `linear-gradient(180deg, transparent 82%, ${alpha(
                theme.palette.secondary.main,
                0.3,
              )} 0%)`,
            }}
          >
            made simple
          </Typography>
        </Typography>
      </Box>
      <Box marginBottom={3}>
        <Typography variant="h6" component="p" color="text.secondary">
          For entrepreneurs, startups and freelancers. Discover coworking spaces
          designed to inspire and to connect you to a community of motivated
          people.
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretched', sm: 'flex-start' }}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth={!isMd}
          component="a"
          href="contact-us"
        >
          Book a space
        </Button>
      </Box>
    </Box>
  );

  const RightSide = () => {
    const sliderOpts = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    };

    return (
      <Box
        sx={{
          height: { xs: 'auto', md: 1 },
          '& .slick-slide img': {
            objectFit: 'cover',
          },
          '& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div':
            {
              height: { xs: 'auto', md: 1 },
            },
          '& .slick-prev, & .slick-next': {
            zIndex: 2,
            bottom: 0,
            top: '100%',
            left: '100%',
            right: 0,
            transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
            marginLeft: theme.spacing(-2),
            width: 32,
            height: 32,
            marginY: 'auto',
            '&:before': {
              fontSize: 32,
            },
          },
          '& .slick-prev': {
            marginLeft: theme.spacing(-7),
          },
          '& .lazy-load-image-loaded': {
            height: 1,
            width: 1,
          },
        }}
      >
        <Slider {...sliderOpts}>
          {[
            assets.coworkingSpace.heroImage1,
            assets.coworkingSpace.heroImage2,
            assets.coworkingSpace.heroImage3,
            assets.coworkingSpace.heroImage4,
          ].map((item) => (
            <Box
              key={item}
              component={LazyLoadImage}
              effect="blur"
              src={item}
              height={{ xs: 'auto', md: 1 }}
              maxHeight={{ xs: 300, md: 1 }}
              width={'100vw'}
              maxWidth={1}
              borderTopLeftRadius={{ xs: 0, sm: 0, md: 20, lg: 20, xl: 20 }}
              sx={{
                borderBottomLeftRadius: {
                  xs: 0,
                  sm: 0,
                  md: 10,
                  lg: 10,
                  xl: 10,
                },
                borderTopLeftRadius: { xs: 0, sm: 0, md: 20, lg: 20, xl: 20 },
              }}
            />
          ))}
        </Slider>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        overflow: 'hidden',
        backgroundColor: '#f2f7ff',
      }}
    >
      <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'row' }}
          position={'relative'}
          minHeight={{ xs: 'auto', md: 600 }}
        >
          <Box
            order={{ xs: 2, md: 1 }}
            display={'flex'}
            alignItems={'center'}
            sx={{
              width: 1,
              height: 'fit-content',
              margin: 'auto',
              position: { xs: 'none', sm: 'none', md: 'relative' },
              left: 100,
              zIndex: 1,
              borderRadius: 5,
              backgroundColor: 'white',
            }}
          >
            <Container>
              <LeftSide />
            </Container>
          </Box>
          <Box
            sx={{
              flex: { xs: '0 0 100%', md: '0 0 50%' },
              position: 'relative',
              maxWidth: { xs: '100%', md: '50%' },
              order: { xs: 1, md: 2 },
            }}
          >
            <Box
              sx={{
                width: { xs: 1, md: '50vw' },
                height: '94%',
                position: 'relative',
                marginY: '3%',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden',
                  margin: 'auto',
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    width: 1,
                    left: '0%',
                    height: 1,
                    marginRight: 5,

                    position: { xs: 'relative', md: 'absolute' },
                    clipPath: {
                      xs: 'none',
                      // md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                    },
                    shapeOutside: {
                      xs: 'none',
                      // md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                    },
                  }}
                >
                  <RightSide />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      <Divider />
    </Box>
  );
};

export default Hero;
